



















































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
// @ts-ignore
import FocusLock from 'vue-focus-lock';
import {GetterTypes as UserGetterTypes} from '@/store/user/types';
import {User} from '@/models/User';
import PwrLangSelector from '@/components/Pwr/PwrLangSelector/PwrLangSelector.vue';
import './Navbar.scss';
import flagPl from '@/assets/pwr/icons/poland_flag.svg';
import flagEn from '@/assets/pwr/icons/united_kingdom_flag.svg';
import UserService from '../../services/UserService';

const userNamespace: string = 'user';

@Component({
  components: {
    PwrLangSelector,
    FocusLock
  }
})
export default class Navbar extends Vue {
  @Getter(UserGetterTypes.GET_LOGGED_USER, {namespace: userNamespace}) loggedUser!: User | null;

  private isHamburgerMenuOpen: boolean = false;

  private userService: UserService = new UserService();

  private async logout(): Promise<void> {
    await this.userService.logout();

    if (this.$route.path !== '/login') {
      this.$router.push('/login');
    }
  }

  private isUserAdmin(): boolean {
    if (this.loggedUser !== null) {
      return this.loggedUser.roles.includes('super administrator') || this.loggedUser.roles.includes('administrator');
    }

    return false;
  }

  private openMenu(): void {
    this.isHamburgerMenuOpen = !this.isHamburgerMenuOpen;

    if (this.isHamburgerMenuOpen) {
      const mainMenu = document.querySelector('#main-menu');

      if (mainMenu) {
        const menuElement = mainMenu.children[0] as HTMLElement;

        this.$nextTick(() => {
          menuElement.focus();
        });
      }
    }
  }

  private changeRouteToAdminPanel(): void {
    if (this.$route.path !== '/admin') {
      this.openMenu();
      const hamburger: HTMLInputElement | null = document.querySelector('#hamburger');

      if (hamburger) {
        hamburger.checked = false;
      }

      this.$router.push('/admin');
    }
  }

  private changeRouteToUserQueuesPanel(): void {
    if (this.$route.path !== '/app') {
      this.$router.push('/app');
    }
  }

  private get getUserInitials(): string | null {
    if (this.loggedUser !== null) {
      const {name, surname, email} = this.loggedUser;

      if (name !== null && surname != null) {
        return `${name[0]}${surname[0]}`;
      }

      if (email !== null) {
        return `${email[0]}${email[1]}`;
      }
    }

    return null;
  }

  get getFlags() {
    return {
      pl: flagPl,
      en: flagEn
    };
  }
}
